import { EventUtil } from "../util/EventUtil";

class ModuleTracking {
  public readonly ModuleTrackingLoadedEvent:
  string = "ModuleTrackingLoadedEvent";
  private static readonly trackableElements: string = "a, button, span, input, i, div[data-track]";

  public static GoogleEvent(
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
    eventValue: number | null,
    eventDestinationUrl?: string
  ): void {
    if (typeof(gtag) === "function") {
      const eventPayload: Record<string, string | number | null> = {
        'event_action': eventAction,
        'event_category': eventCategory,
        'event_label': eventLabel,
        'value': eventValue
      };
      if (eventDestinationUrl && eventDestinationUrl.trim() !== "") {
        eventPayload.event_destination_url = eventDestinationUrl;
      }
      gtag('event', eventAction, eventPayload );
    } else {
      console.warn("GTAG has not been loaded/initialized, trying GA...");
      if (typeof(ga) === "function") {
        ga("send", "event", eventCategory, {
          eventAction,
          eventCategory,
          eventLabel,
          eventValue
        });
      } else {
        console.warn("GA has not been loaded/initialized");

        return;
      }
      console.log("Event Category: " + eventCategory);
      console.log("Event Action: " + eventAction);
      console.log("Event Label: " + eventLabel);
    }
  }

  public static ModuleTrackCategory(t: HTMLElement): string {
    const closestCategory = t.closest("[data-module-track-category]");
    if (!closestCategory) {
      return "";
    }
    const val = closestCategory.getAttribute("data-module-track-category");
    if (!val) {
      return "";
    }

    return val;
  }

  public static ModuleTrackAction(t: HTMLElement): string {
    const closestAction = t.closest("[data-module-track-action]");
    if (!closestAction) {
      return "";
    }
    const val = closestAction.getAttribute("data-module-track-action");
    if (!val) {
      return "";
    }

    return val;
  }

  public static ModuleTrackLabel(t: HTMLElement): string {
    const closestLabel = t.closest("[data-module-track-label]");
    if (!closestLabel) {
      return "";
    }
    const val = closestLabel.getAttribute("data-module-track-label");
    if (!val) {
      return "";
    }

    return val;
  }

  public static ModuleTrackDestinationUrl(t: HTMLElement): string {
    let current: HTMLElement | null = t;
    for (let depth = 0; current !== null && depth <= 3; depth++) {
      const href = current.getAttribute("href");
      if (href) {
        return href;
      }

      const destinationUrl = current.getAttribute(
        "data-module-track-destination-url"
      );
      if (destinationUrl) {
        return destinationUrl;
      }

      current = current.parentElement;
    }

    return "";
  }

  public TrackLinks(): void {
    console.log("Module tracking loaded.");
    const elements = document.querySelectorAll(ModuleTracking.trackableElements);
    elements.forEach((element) => {
      element.removeEventListener("click", ModuleTracking.trackElement);
      if (!element.hasAttribute("data-notrack")) {
        element.addEventListener("click", ModuleTracking.trackElement);
      }
    });
    window.modtrkloaded = true;
    const modTrkLoadedEvent =
    EventUtil.createCustomEvent(this.ModuleTrackingLoadedEvent, null);
    window.dispatchEvent(modTrkLoadedEvent);
  }

  public AjaxTrackLinks(selection: HTMLElement,
      ConsoleLabel: string|null): void {
    // tslint:disable-next-line: restrict-plus-operands
    console.log("Ajax Track Click: " + ConsoleLabel);    
    const elements = selection.querySelectorAll(ModuleTracking.trackableElements);
    elements.forEach((element) => {
      element.removeEventListener("click", ModuleTracking.trackElement);  
      if (!element.hasAttribute("data-notrack")) {
        element.addEventListener("click", ModuleTracking.trackElement);
      }
    });
  }  

  public UseGoogleTrack(cat: string, act: string, lab: string) {
    ModuleTracking.GoogleEvent(cat, act, lab, 0)
  }

  public async init(): Promise<void> {
    this.TrackLinks();
  }

  private static trackElement(event: Event): void {
    const el = event.currentTarget as HTMLElement;
    const eventCategory = ModuleTracking.ModuleTrackCategory(el);
    const eventAction = ModuleTracking.ModuleTrackAction(el);
    const eventLabel = ModuleTracking.ModuleTrackLabel(el);
    const eventDestinationUrl = ModuleTracking.ModuleTrackDestinationUrl(el);
    if (eventCategory === "" || eventAction === "" || eventLabel === "") {
      return;
    }
    // console.log($(this).attr("class"));
    if (el.classList.contains("trendmd-widget-list-item__link")) {
      return;
    }
    ModuleTracking.GoogleEvent(
      eventCategory,
      eventAction,
      eventLabel,
      null,
      eventDestinationUrl
    );
  }
}

export const moduletracking = new ModuleTracking();
